export const AppAPIName = 'AppAPI';

export const UnAuthAPIName = 'UnAuthAPI';
